import { Link } from "react-router-dom";
import { CalendarCheck, Clock3, ShieldCheck } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { useSEO } from "../hooks/useSEO";
import { Button } from "../components/ui/button";
import { USPs } from "../components/home/USPs";
import { Reviews } from "../components/home/Reviews";
import { LocationSection } from "../components/home/LocationSection";

export default function AfspraakMaken() {
  const { lang } = useLanguage();
  useSEO(
    lang === "nl"
      ? "Afspraak maken bij de kapper in Utrecht | EliteTheBarber"
      : "Book an appointment with the barber in Utrecht | EliteTheBarber",
    lang === "nl"
      ? "Maak in een paar klikken een afspraak bij EliteTheBarber in Utrecht. Kies je dienst, datum en tijd en ontvang direct een bevestiging met afspraaknummer."
      : "Book an appointment with EliteTheBarber in Utrecht in a few clicks. Pick your service, date and time and get an instant confirmation with appointment number."
  );

  const steps = [
    { icon: CalendarCheck, nl: "Kies je dienst, datum en tijd", en: "Pick your service, date and time" },
    { icon: Clock3, nl: "Ontvang direct een bevestiging met afspraaknummer", en: "Get an instant confirmation with appointment number" },
    { icon: ShieldCheck, nl: "Wijzig of annuleer je afspraak eenvoudig online", en: "Easily reschedule or cancel your appointment online" },
  ];

  return (
    <div data-testid="afspraak-maken-page">
      <section className="py-24 sm:py-32 px-4 sm:px-6 text-center bg-[#0A0A0A]">
        <div className="max-w-3xl mx-auto">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4">EliteTheBarber &middot; Utrecht</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mb-6 tracking-tight">
            {lang === "nl" ? "Afspraak maken bij de kapper" : "Book your barber appointment"}
          </h1>
          <p className="text-white/60 text-base sm:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
            {lang === "nl"
              ? "Geen telefoontjes, geen wachtrijen. Boek je afspraak bij EliteTheBarber Utrecht in minder dan een minuut en ontvang direct een bevestiging per e-mail."
              : "No phone calls, no queues. Book your appointment with EliteTheBarber Utrecht in under a minute and get an instant email confirmation."}
          </p>
          <Link to="/boeken">
            <Button data-testid="afspraak-maken-cta-button" className="bg-gold text-white hover:bg-gold-hover rounded-none px-10 py-6 text-base">
              {lang === "nl" ? "Start je afspraak" : "Start your booking"}
            </Button>
          </Link>
        </div>
      </section>

      <section className="py-16 sm:py-20 px-4 sm:px-6 bg-[#080808]">
        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6">
          {steps.map((s, idx) => (
            <div key={s.nl} data-testid={`afspraak-maken-step-${idx}`} className="bg-[#141414] border border-white/5 rounded-xl p-8 text-center">
              <s.icon size={26} className="text-gold mx-auto mb-4" />
              <p className="text-white/80 text-sm leading-relaxed">{lang === "nl" ? s.nl : s.en}</p>
            </div>
          ))}
        </div>
      </section>

      <USPs />
      <Reviews />
      <LocationSection />
    </div>
  );
}
